import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function customerGroupReducer(state = initialState.customerGroups, action) {
    let newState = state;

    switch (action.type) {
        case types.CREATE_CUSTOMER_GROUP_PROJECT:
            if (action.status === 'success'){
                newState = createCustomerGroupProject(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_CUSTOMER_GROUP_PROJECT:
            if (action.status === 'success'){
                newState = deleteCustomerGroupProject(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_CUSTOMER_GROUPS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    customerGroups: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_CUSTOMER_GROUPS_BY_PROJECT:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    active: false,
                    customerGroupProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SAVE_CUSTOMER_GROUP:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    customerGroups: [...state.customerGroups, action.data],
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;


        case types.SET_LOADING_FLAG_FOR_CUSTOMER_GROUP_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        default:
            return state;
    }
}

function createCustomerGroupProject(state, customerGroupProject) {
    return Object.assign({}, state, {
        loading: false,
        customerGroupProjects: [...state.customerGroupProjects, customerGroupProject]
    });
}

function deleteCustomerGroupProject(state, customerGroupProject) {

    let customerGroupProjects = state.customerGroupProjects;
    let index = customerGroupProjects.indexOf(customerGroupProject);

    customerGroupProjects.splice(index, 1);

    return Object.assign({}, state, {
        loading: false,
        customerGroupProjects
    });
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/customerGroupReducer.js
 **/